import script from "./HomePrimaryHero.vue?vue&type=script&setup=true&lang=js"
export * from "./HomePrimaryHero.vue?vue&type=script&setup=true&lang=js"

import "./HomePrimaryHero.vue?vue&type=style&index=0&id=74362816&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74362816"]])

export default __exports__